/**
 * Barra de anuncios con mensajes rotativos. Se pausa al pasar el ratón o al
 * enfocar, y no rota sola si el visitante prefiere reducir el movimiento.
 */
import { prefersReducedMotion } from '@theme/global';

class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.announcement__item')];
    this.index = 0;
    this.interval = parseInt(this.dataset.interval, 10) || 4000;
    if (this.items.length < 2) return;

    this.querySelector('[data-announcement-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.show(this.index + 1));

    ['mouseenter', 'focusin'].forEach((type) => this.addEventListener(type, () => this.stop()));
    ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => this.start()));
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    if (prefersReducedMotion()) return;
    this.stop();
    this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
  }

  stop() {
    window.clearInterval(this.timer);
  }

  show(index) {
    this.index = (index + this.items.length) % this.items.length;
    this.items.forEach((item, i) => {
      const active = i === this.index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', String(!active));
      item.querySelectorAll('a').forEach((link) => {
        if (active) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', '-1');
      });
    });
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
